/**
 * @desc 导出物流订单tms单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.transportMaster.exportTraTmsReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportTraTMSReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
